import { MergeUnion } from '@deltasierra/type-utilities';

export type ReducedMergedArrayResult<T extends ReadonlyArray<Record<keyof never, any>>> = MergeUnion<T[number]>;

/**
 * Reduces an array of objects to a single merged object
 *
 * @param arr - The array
 * @returns The merged object
 */
export function reduceMergeArray<T extends ReadonlyArray<Record<keyof never, unknown>>>(
    arr: T,
): ReducedMergedArrayResult<T> {
    return arr.reduce((carry, current) => ({ ...carry, ...current }), {}) as unknown as ReducedMergedArrayResult<T>;
}
